export const EntryOrderType = {
    SCRK: 1,
    LYRK: 2,
    DHRK: 3,
    CCRK: 4,
    DBRK: 5,
    B2BRK: 6,
    XNRK: 7,
    RKQD: 8,
    STRK: 12,
    THRK: 13,
    HHRK: 14,
    JSRK: 15,
    LJRK: 16,
    YCRK: 17,
    CPRK: 18,
    QTRK: 19,

    PTCK: 20,
    DBCK: 21,
    CGTH: 24,
    YLCK: 27,
    XSCK: 28,
    PDDJ: 40,
    PDRW: 47,
    RWPD: 48,
    JHQD: 60,
    CNDD: 61,
    KWZY: 62
}

const map = {
    3: '到货单',
    5: '调拨入库',
    8: '入库清点',
    12: '售退入库',
    13: '退款收货入库',
    14: '换货收货入库',
    15: '仅收货入库',
    16: '拦截入库',
    17: '异常入库',
    18: '次品入库',
    20: '调货出库',
    21: '仓库调拨',
    24: '采购退货出库',
    27: '预留货品',
    28: '销售出库',
    40: '盘点单据',
    47: '盘点任务',
    48: '任务盘点',
    60: '拣货清单',
    61: '仓内调动',
    62: '库位转移'
}

const abbreviationMap = {
    3: 'DHRK',
    5: 'DBRK',
    8: 'RKQD',
    12: 'STRK',
    13: 'THRK',
    14: 'HHRK',
    15: 'JSRK',
    16: 'LJRK',
    17: 'YCRK',
    18: 'CPRK',
    20: 'PTCK',
    21: 'DBCK',
    24: 'CGTH',
    27: 'YLCK',
    28: 'XSCK',
    40: 'PDDJ',
    47: 'PDRW',
    48: 'RWPD',
    60: 'JHQD',
    61: 'CNDD',
    62: 'KWZY'
}

const getDescribe = (orderType) => {
    return map[orderType] || ''
}

const getAbbreviation = (orderType) => {
    return abbreviationMap[orderType] || ''
}

export default {
    EntryOrderType,
    getDescribe,
    getAbbreviation
}



// WEBPACK FOOTER //
// ./src/utils/newSys/entryOrderType.js